import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { get } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { GamePlayerApi } from "states/api/gamePlayer";
import { formatNumber } from "_common/utils/formatValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faLongArrowAltLeft,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useNotify } from "_common/component/NotifyProvider";
import classNames from "classnames";
import NoData from "_common/component/NoData";

export default function HistoryData({ status }) {
  const navigate = useNavigate();
  const [item, setItem] = useState();
  const { dataGame } = useNotify();

  const { data, refetch } = useQuery(
    ["game-player", "trade", status],
    () =>
      GamePlayerApi.getList({
        params: {
          page: 1,
          limit: 20,
          type: "trade",
          status,
        },
      }),
    {
      staleTime: 300000,
    }
  );

  useEffect(() => {
    refetch();
  }, [status]);

  if (!data?.data?.length) return <NoData />;

  return (
    <div className="mx-auto w-full">
      <div className="flex flex-col gap-2">
        <div className="flex flex-col">
          {get(data, "data", [])?.map((item) => {
            const time = Number(get(dataGame?.[item?.id], "time", 0));
            const type = Number(get(item, "type", 360));
            const process = (time / type) * 100;
            return (
              <div
                className="flex flex-col gap-1 p-4 border-b border-[#ffffff1a]"
                key={item?.id}
              >
                <div className="flex justify-between">
                  <div className="flex  gap-1 items-center">
                    <div className="text-white text-[16px]">
                      {item?.game?.name?.replace("/USDT", "")}
                      <span className="text-[#9ca3af]">/USDT</span>
                    </div>
                    {item?.bet_game === "buy" && (
                      <div className="py-1 px-3 text-[13px] text-white rounded bg-[#55af72]">
                        {i18next.t("transaction_purchaser")}{" "}
                        {formatNumber(Number(get(item, "type", 0) / 60))} phút
                      </div>
                    )}
                    {item?.bet_game === "sell" && (
                      <div className="py-1 px-3 text-[13px] text-white rounded bg-[#dd5350]">
                        {i18next.t("transaction_sell")}{" "}
                        {formatNumber(Number(get(item, "type", 0) / 60))} phút
                      </div>
                    )}
                  </div>
                </div>
                <div className="mt-1">
                  <div className="flex-1 flex items-center  gap-1 ">
                    <span className="text-[14px] text-[#888]">
                      {i18next.t("old_balance")}:
                    </span>
                    <span className="text-[13px] text-white">
                      {formatNumber(item?.old_balance, "0,0.[0000]")} USDT
                    </span>
                  </div>
                  <div className="flex-1 flex items-center gap-1">
                    <span className="text-[14px] text-[#888]">
                      {i18next.t("finish_balance")}:
                    </span>
                    <span className="text-[13px] text-white">
                      {formatNumber(item?.new_balance, "0,0.[0000]")} USDT
                    </span>
                  </div>
                </div>
                <div className="flex">
                  <div className="flex-1 flex flex-col gap-1">
                    <span className="text-[14px] text-[#888]">
                      {i18next.t("price_transaction")}
                    </span>
                    <span
                      className={classNames("text-[13px] ", {
                        "text-[#55af72]": item?.bet_game === "buy",
                        "text-[#dd5350]": item?.bet_game === "sell",
                      })}
                    >
                      {formatNumber(item?.open, "0,0.[0000]")}{" "}
                    </span>
                  </div>
                  <div className="flex-1 flex flex-col gap-1">
                    <span className="text-[14px] text-[#888]">
                      {i18next.t("money_amount")}
                    </span>
                    <span className="text-[13px] text-white">
                      {formatNumber(item?.amount, "0,0.[0000]")} USDT
                    </span>
                  </div>
                  <div className="flex-1 flex flex-col items-end gap-1">
                    <span className="text-[14px] text-[#888]">
                      {i18next.t("profit")}
                    </span>
                    {item?.amount_payback > 0 && (
                      <span className="text-[13px] text-[#f7a600]">
                        +{formatNumber(item?.amount_payback, "0,0.[000000]")}{" "}
                        USDT
                      </span>
                    )}
                    {item?.amount_lose > 0 && (
                      <span className="text-[13px] text-[#dd5350]">
                        -{formatNumber(item?.amount_lose, "0,0.[000000]")} USDT
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <span className="w-full text-[#9ca3af] text-[13px] pb-3 text-center">
          {i18next.t("no_more_data")}
        </span>
      </div>
    </div>
  );
}
